export { NileTableHeaderItem } from './nile-table-header-item';
